import { defineFilterSpec, enumField, rangeField, text } from '@/lib/api/filter-spec';

import type { PaymentFilterFormValues, PaymentListFilters } from './types';

/** Single declaration of the payment list filters, shared by api/drawer/page. All selects are
 *  single-value (enum); ranges follow `${base}From`/`${base}To`; date bounds pass through as enum. */
const spec = defineFilterSpec<PaymentListFilters, PaymentFilterFormValues>([
  text('search'),
  enumField('paymentFor'),
  enumField('paymentStatus'),
  enumField('paymentMethod'),
  rangeField('deviceCount'),
  rangeField('amount'),
  enumField('paidFrom'),
  enumField('paidTo'),
]);

export const toListQuery = spec.toListQuery;
export const toDefaults = spec.toDefaults;
export const toFilters = spec.toFilters;
export const hasActiveFilters = spec.hasActiveFilters;
